import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import styles from './CallDescription.styles.m.css';

interface ICallDescriptionProps {
  className?: string;
}

export const CallDescription: FC<ICallDescriptionProps> = observer(({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.textBlock}>
        <h2 className={styles.title}>{t('call_device_settings_window_header')}</h2>
        <h3 className={styles.subTitle}>{t('call_device_settings_window_tips_message')}</h3>
      </div>
    </div>
  );
});
